<template>
  <van-nav-bar
  title="中国传媒大学新生住宿办理"
/>
<div class="indexlogo">
  <img src="../../images/zhongchuan.png" style="width:260px;" border="0" />
  </div>
  <van-form @submit="onSubmit" ref="formline">
    <van-field
      v-model="form.loginname"
      name="loginname"
      label="管理账号"
      placeholder="请填写管理账号" 
      :rules="[{ required: true, message: '请填写管理账号' }]" 
    />     
    <van-field
      v-model="form.password"
      type="password"
      name="password"
      label="密  码"
      placeholder="请填写密码"
      :rules="[{ required: true, message: '请填写密码' }]" 
      
    />
    <div style="margin: 16px" :class="{submitselect:form.active }" >
      <van-row gutter="20">
        <van-col span="12"
          ><van-button block type="primary" @click="onDelete"
            >重置</van-button
          ></van-col
        >
        <van-col span="12"
          ><van-button block type="primary" native-type="submit"
            >登录</van-button
          ></van-col
        >
      </van-row>
    </div>
   <div style="margin: 16px" :class="{submitselect:!form.active }" >
      <van-row gutter="20">
        <p class="center">登录成功，请重新扫码！</p>
      </van-row>
    </div>
  </van-form>
    <div class="login-copyright">Copyright © {{new Date().getFullYear()}} 中国传媒大学 All Rights Reserved.</div>

</template>
<style lang="scss" scoped>
   .login-copyright {
    position:relative;
    margin-top:40%;
  }
  .submitselect{
    display: none;
  }
  .center{
    text-align: center;
    margin: 0 auto;
  }
</style>
<script>
import { reactive } from "vue";
import { Toast } from "vant";
import { Managelogin } from "../../http/api.manage.ts";
import { Dialog } from 'vant';

export default {
  setup() {
    let form = reactive({
      loginname: "",
      password: "",
      checkbox: "",
      active:false
    });
    return {
      form
    };
  },
  methods: {
    onSubmit(form) {   
      const toast1 = Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      Managelogin(form).then((res) => {        
         if (res.code == 200) {          
          localStorage.setItem("ManageuserToken", "Bearer " + res.token);
          localStorage.setItem("Manageusername", res.datas.UserName);
          console.info(this.form.active);
          this.form.active=true;
          Dialog({ message: '登录成功，请重新扫码！' });
          
        } else {
          Dialog({ message: res.msg });
        }
        toast1.clear();
      });
    },
    onDelete() {
        this.form.loginname='';
        this.form.password='';
    },    
  },
};
</script>